module.exports = __webpack_public_path__ + "static/assets/f847d76906912ea9499ee16146437d2b.png";